export default async function sanitize<I>(input: I): Promise<I> {
	if (typeof input === "string") {
		const { default: purify } = await import("dompurify");
		return purify.sanitize(input) as I;
	}
	if (Array.isArray(input)) {
		return (await Promise.all(input.map((item) => sanitize(item)))) as I;
	}
	if (typeof input === "object" && input !== null) {
		const sanitizedObject: Record<string, unknown> = {};
		for (const key in input) {
			if (Object.prototype.hasOwnProperty.call(input, key)) {
				sanitizedObject[key] = await sanitize(input[key]);
			}
		}
		return sanitizedObject as I;
	}
	return input;
}
